import React from 'react';

const Close = () => (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/close-open" fill="#1BC77E">
                <path
                    d="M22.1999026,20 L28.3333333,26.1334307 L26.1334307,28.3333333 L20,22.1999026 L13.8665693,28.3333333 L11.6666667,26.1334307 L17.8000974,20 L11.6666668,13.8665695 L13.8665695,11.6666668 L20,17.8000974 L26.1334307,11.6666667 L28.3333333,13.8665693 L22.1999026,20 Z"
                    id="x"
                ></path>
            </g>
        </g>
    </svg>
);

export default Close;
